import { IAuthServiceV2 } from '@volkswagen-onehub/authservice';
import { getRequest, deleteRequest, postRequest } from './fetch';

export interface INewsFeed {
    feedID: string;
    title: string;
    description: string;
    feedUrl: string;
    logoUrl: string;
    language: string;
    pos: number;
    active: boolean;
}

export interface INewsFeeds {
    standardFeeds: INewsFeed[];
    personalFeeds: INewsFeed[];
}

export interface INewsFeedsResponse {
    data?: INewsFeeds;
}

export class VcfNewsFeedsClient {

    private readonly headers: HeadersInit = {
        'User-Id': '__userId__',
        'Content-Type': 'application/json',
    };

    private readonly resourceHostId: string;

    private getGdcType = (isWcar: boolean) => isWcar ? `myvw-wcar-${this.stage}` : `myvw-mbb-${this.stage}`;

    constructor(private readonly authService: IAuthServiceV2, private readonly stage: string) {
        this.resourceHostId = `myvw-vcf-${stage}`
    };


    public async getNewsFeeds(vin: string, isWcar: boolean):Promise<INewsFeedsResponse> {
        const url = `vehicles/${vin}/newsfeeds?gdc=${this.getGdcType(isWcar)}`;
        return getRequest(this.authService, this.resourceHostId, url, this.headers);
    };

    public async deleteNewsFeed(vin: string, id: string, isWcar: boolean):Promise<any> {
        const url = `vehicles/${vin}/newsfeeds/${id}?gdc=${this.getGdcType(isWcar)}`;
        return deleteRequest(this.authService, this.resourceHostId, url, this.headers)
    };


    public async postNewsfeeds(vin: string, feedUrl: any, isWcar: boolean): Promise<any> {
        const url = `vehicles/${vin}/newsfeeds?gdc=${this.getGdcType(isWcar)}`;
        return postRequest(this.authService, this.resourceHostId, url, feedUrl, this.headers);
    };
}
